import React from "react";
import Div100vh from "react-div-100vh";

import BellIcon from "@/assets/icons/bell-icon.svg";
import CallIcon from "@/assets/icons/call-icon.svg";
import NotifyImg from "@/assets/images/notify-screen-img.svg";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.webp";
import InviteButton from "../common/buttons/InviteButton";

export default function NotifyScreen() {
  return (
    <Div100vh className="flex flex-col justify-between py-5 px-4">
      <style>
        {`
          .hover\\:icon-white:hover img {
            filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(93deg) brightness(102%) contrast(102%);
          }
        `}
      </style>
      <div className="flex flex-col items-center">
        <img
          src={
            "https://sale-crm.s3.amazonaws.com/assets/landlord screen ill.png"
          }
          alt="Eligibility Declined"
          className=""
        />
      </div>
      <div className="flex flex-col gap-6 items-start pl-4">
        <div className="flex flex-col">
          <span className="heading">
            Our team will get in touch with the landlord right away!
          </span>
        </div>
        <div className="flex flex-col">
          <span className="subheading">
            Please inform the landlord to expect a call from us
          </span>
        </div>

        <InviteButton text={"Share CLUB invite"} />
      </div>
      <div className="flex items-center justify-center gap-4">
        Reach out to us
      </div>
    </Div100vh>
  );
}
